import { type FundingRound } from "@prisma/client";
import { isArray } from "~/lib/lodash";

const FundingRoundFormats: Record<FundingRound, string> = {
  NOT_SHARED: "Unable to share",
  PRE_SEED: "Pre-seed",
  SEED: "Seed",
  SERIES_A: "Series A",
  SERIES_B: "Series B",
  SERIES_C: "Series C",
  SERIES_D: "Series D",
  SERIES_E: "Series E",
  POST_ACQUISITION: "Post-acquisition",
  POST_IPO: "Post-IPO",
  PUBLIC_FUNDING: "Public Funding",
  SELF_FINANCED: "Self-financed",
};

export const formatFundingRounds = (fundingRound: FundingRound[] | FundingRound): string => {
  if (isArray(fundingRound)) return fundingRound.map((round) => FundingRoundFormats[round]).join(", ");

  return FundingRoundFormats[fundingRound];
};
